const UEBenefitsSection = () => (
  <section id="why">
    <div className="section-inner">
      <div className="section-head">
        <span className="section-label">
          <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="m9 12 2 2 4-4" />
            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9Z" />
          </svg>
          Benefits
        </span>
        <h2 className="section-title">More than a delivery gig.</h2>
        <p className="section-lead">
          You&apos;re a Flink employee who delivers for Uber Eats customers.
        </p>
      </div>

      <div className="benefits-grid">
        <article className="benefit-card feature">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3v8Z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          </div>
          <div className="benefit-title">The role</div>
          <h3 className="benefit-headline">A real Flink employment contract</h3>
          <p className="benefit-body">
            Benefit from a formal contract that includes built-up holiday hours (8%), holiday
            allowance, and sick pay.
          </p>
        </article>

        <article className="benefit-card">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <div className="benefit-title">Hourly wage</div>
          <h3 className="benefit-headline">Up to €16.19/h</h3>
          <p className="benefit-body">
            Paid by the hour from the moment your shift starts — not per delivery, not per route.
            Full age-banded table further down.
          </p>
        </article>

        <article className="benefit-card">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="5.5" cy="17.5" r="3.5" />
              <circle cx="18.5" cy="17.5" r="3.5" />
              <path d="M15 6h4l-2 6M5 17l5-10h4l3 6" />
            </svg>
          </div>
          <div className="benefit-title">Km bonus</div>
          <h3 className="benefit-headline">+€0.19–€0.24 per km</h3>
          <p className="benefit-body">
            Every kilometre you ride on shift earns extra on top of your hourly wage. On a 30-hour
            week, that&apos;s roughly €170/mo extra on a bike, €218/mo extra on a scooter.
          </p>
        </article>

        <article className="benefit-card">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2v6m0 0c-2 0-4 1-4 3v9h8v-9c0-2-2-3-4-3Z" />
              <circle cx="9" cy="13" r="0.6" fill="currentColor" />
              <circle cx="15" cy="13" r="0.6" fill="currentColor" />
            </svg>
          </div>
          <div className="benefit-title">Tips</div>
          <h3 className="benefit-headline">100% of every tip, yours</h3>
          <p className="benefit-body">
            Tips go straight to you. Not split, not pooled, not skimmed. Processed separately from
            payroll and transferred directly.
          </p>
        </article>

        <article className="benefit-card">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M8 2v4M16 2v4M3 10h18" />
            </svg>
          </div>
          <div className="benefit-title">Schedule</div>
          <h3 className="benefit-headline">Pick the shifts you want</h3>
          <p className="benefit-body">
            Book shifts that suit your week in the Uber Eats scheduling system. Weekly payroll, on
            time, every time.
          </p>
        </article>

        <article className="benefit-card">
          <div className="benefit-icon">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0Z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>
          <div className="benefit-title">Where</div>
          <h3 className="benefit-headline">All over Amsterdam, Groningen and Rotterdam</h3>
          <p className="benefit-body">
            The partnership runs across eight regions of Amsterdam, Groningen and Rotterdam,
            covering almost the full city.
          </p>
        </article>
      </div>
    </div>
  </section>
);

export default UEBenefitsSection;
